import React from 'react'

import {
  Alert,
  AlertDescription,
  AlertIcon,
  Box,
  CloseButton,
} from '@chakra-ui/react'

/**
 * Props for the StaticBanner component
 */
export interface StaticBannerIProps {
  message: string
  status: 'warning' | 'error' | 'info' | 'success'
  onDismiss: () => void
}

/**
 * Static banner component for displaying product messages.
 */
export const StaticBanner: React.FC<StaticBannerIProps> = ({
  message,
  status,
  onDismiss,
}) => {
  return (
    <Box
      aria-label='Product announcement'
      role='banner'
      width='100%'
      zIndex='banner'
    >
      <Alert
        borderRadius='0'
        fontSize='sm'
        justifyContent='center'
        px='6'
        py='3'
        role='alert'
        status={status}
      >
        <AlertIcon aria-hidden='true' />
        <AlertDescription
          fontWeight='medium'
          maxWidth='container.lg'
          textAlign='center'
        >
          {message}
        </AlertDescription>
        <CloseButton
          aria-label='Dismiss announcement'
          onClick={onDismiss}
          position='absolute'
          right='8px'
          top='8px'
        />
      </Alert>
    </Box>
  )
}
